import React, { useState, useContext, useEffect } from "react";
import SettingsContext from "../../../../../../context/settings/settingsContext";
import { useNavigate } from "react-router-dom";
const initialState = {
  roofColor: { color: { name: "", code: "" } },
};

const AddRoofColor = ({ selectedRoofColor, setSelectedRoofColor }) => {
  const navigate = useNavigate();

  const settingsContext = useContext(SettingsContext);
  const { settings, getSettings, updateSettings } = settingsContext;

  const [values, setValues] = useState(initialState);
  // destructure
  const { roofColor } = values;

  useEffect(() => {
    getSettings();
  }, []);

  useEffect(() => {
    getSettings();
    if (selectedRoofColor) {
      setValues({
        roofColor: selectedRoofColor,
      });
    }
  }, [selectedRoofColor]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Make a copy of the settings's roofColors array
    let updatedRoofolors = [...settings.roofColors];
    // If a color is selected, update it
    if (selectedRoofColor) {
      const oldColorId = selectedRoofColor._id; // the old color's _id
      const newColor = values.roofColor.color; // the new color
      // Find the index of the old color
      let index = updatedRoofolors.findIndex((color) => color._id === oldColorId);
      // Replace the old color with the new color
      if (index !== -1) {
        updatedRoofolors[index].color = newColor;
      }
    } else {
      // If no color is selected, add a new one
      const newColor = values.roofColor.color; // the new color
      updatedRoofolors.push({ color: newColor });
    }
    // Update the settings
    let updatedSettings = { ...settings, roofColors: updatedRoofolors };
    updateSettings(updatedSettings);
    // Reset the form values
    setSelectedRoofColor(null);
    setValues(initialState);
  };

  const handleChange = (e) => {
    const [field, nestedField, nestedNestedField] = e.target.name.split(".");
    setValues((prevValues) => {
      const newValues = {
        ...prevValues,
        [field]: {
          ...prevValues[field],
          [nestedField]: {
            ...prevValues[field][nestedField],
            [nestedNestedField]: e.target.value,
          },
        },
      };
      return newValues;
    });
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <form onSubmit={handleSubmit}>
      <h4 style={{ textAlign: "center" }}>Roof Color</h4>

      <div className="form-group">
        <label>Color</label>
        <input
          type="string"
          name="roofColor.color.name"
          className="form-control inputbg"
          value={roofColor.color.name}
          onChange={handleChange}
        />
      </div>
      <div className="form-group">
        <label>Code</label>
        <input
          type="string"
          name="roofColor.color.code"
          className="form-control inputbg"
          value={roofColor.color.code}
          onChange={handleChange}
        />
      </div>
      <button className="btn btn-prime float-end mb-2 mt-4">Save Roof Color</button>
    </form>
  );
};

export default AddRoofColor;
